import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    EmvioValidatedForm,
    EmvioValidatedButton,
    EmvioValidatedInput
} from '@nexio/emvio-form-components';
import '../Login.scss';
import '../LoginForm/LoginForm.scss';

export default class ForgotPassword extends Component {
    static propTypes = {
        email: PropTypes.string,
        isLoading: PropTypes.bool,
        onReturnToLogin: PropTypes.func.isRequired,
        onSendVerificationCode: PropTypes.func,
        onUpdateEmail: PropTypes.func
    };

    render() {

        return (
            <div>
                <div className="subtitle">
                    Enter your email to reset your password
                </div>
                <EmvioValidatedForm
                    className="forgot-password-form"
                    onSubmit={this.props.onSendVerificationCode(this.props.email)}>
                    <div className="login-row">
                        <EmvioValidatedInput
                            autoCapitalize="off"
                            autoCorrect="off"
                            autoFocus
                            labelText="Email"
                            name="email"
                            onChange={this.props.onUpdateEmail}
                            placeholder="Email"
                            shouldEnforceLowerCase={true}
                            type="text"
                            validations={['required', 'email']}
                            value={this.props.email}
                        />
                    </div>
                    <EmvioValidatedButton isLoading={this.props.isLoading}>
                        SEND VERIFICATION CODE
                    </EmvioValidatedButton>
                    <div className="sub-link">
                        <a href="#" onClick={this.props.onReturnToLogin}>Go Back</a>
                    </div>
                </EmvioValidatedForm>
            </div>
        );
    }
}
